import React from 'react';
import "./Contacts.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';

const Contacts = () => {
  const { t } = useTranslation();

  return (
    <div className="contacts-container">
      <h2 className='h2_contacts'>{t('contact_us')}</h2>
      <p className='p_contacts'>{t('we_would_love')}</p>

      <div className="contact-info">
        <div className="contact-method">
          <h3>{t('email')}</h3>
          <p className='p_contacts'>{t('email_us')}</p>
        </div>

        <div className="contact-method">
          <h3>{t('phone')}</h3>
          <p className='p_contacts'>{t('call_us')}</p>
        </div>

      
      </div>


      <div className="social-media">
        <h3>{t('follow_us')}</h3>
        <div className="social-icons">
          <a href="https://www.facebook.com/profile.php?id=61581409275021" target="" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          
          {/* Add more social media icons as needed */}
        </div>
      </div>
    </div>
  );
};

export default Contacts;
